import * as rdd from "react-device-detect"

const {
  isDesktop,
  isMobile: isMobileRdd,
  getUA: userAgent,
  isFirefox,
  isTablet,
  isMacOs,
  isMobileOnly,
  isWindows,
} = rdd

const DIGITS_MAC_APP_USER_AGENT_PATTERN = /DigitsMac\/|Digits for Mac\b/

export function isDigitsMacUserAgent(ua = userAgent) {
  return DIGITS_MAC_APP_USER_AGENT_PATTERN.test(ua ?? "")
}

const isDigitsMacApp = isDigitsMacUserAgent()
const isSafari = rdd.isSafari || isDigitsMacApp

// Disabling mobile views for tablets (ipad)
const isMobile = isMobileRdd && !isTablet

export type DeviceFlags = Partial<typeof rdd> & {
  isDigitsMacApp: boolean
}

export function addDeviceClasses(
  doc: HTMLElement = document.documentElement,
  devices: DeviceFlags = {
    isDigitsMacApp,
    isFirefox,
    isMacOs,
    isMobile,
    isSafari,
    isTablet,
    isDesktop,
    isWindows,
  }
) {
  if (devices.isDesktop || devices.isTablet) doc.classList.add("desktop")

  // Disabling mobile views for tablets (ipad)
  if (devices.isMobile && !devices.isTablet) {
    doc.classList.add("mobile")
    doc.classList.add("mobile-only")
  }

  if (typeof navigator !== "undefined" && "standalone" in navigator && navigator.standalone) {
    doc.classList.add("standalone")
  }

  if (devices.isSafari) doc.classList.add("safari")
  if (devices.isFirefox) doc.classList.add("firefox")
  if (devices.isMacOs) doc.classList.add("macos")
  if (devices.isWindows) doc.classList.add("win")
  if (devices.isDigitsMacApp) doc.classList.add("digits-mac")
}

/*
  CSS FEATURE DETECTION
*/

export const cssSupports = {
  anchorPositioning:
    typeof CSS !== "undefined" &&
    typeof CSS.supports === "function" &&
    CSS.supports("anchor-name: --a"),
} as const

/*
  EXPORTS
*/

export {
  userAgent,
  isDigitsMacApp,
  isSafari,
  isMobile,
  isMobileOnly,
  isFirefox,
  isTablet,
  isMacOs,
  isDesktop,
  isWindows,
}
